import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'
import moment from 'moment'

import '@/styles/index.scss' // global css

import "@/styles/newhome.scss";

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control
import common from '@/utils/validate'
Vue.prototype.common = common
Vue.prototype.moment = moment

Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.productionTip = false

Vue.prototype.$moment = moment;//时间戳转化

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js